<template>
  <div class="box-body">
    <div class="row m-b-15" v-show="show.info">
      <div class="row center-block">
        <div class="col-md-12">
          <div>
            <br />
            <div class="box-body form-left">
              <div>
                <div class="input-group">
                  <span class="input-group-addon">活動名稱</span>
                  <div class="form-control form-info">{{activity.name}}</div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    活動啟用
                  </span>
                  <div class="form-control form-info">
                    <label class="label label-success" v-if="activity.is_enable.value === 1">啟用</label>
                    <label class="label label-danger" v-else>未啟用</label>
                  </div>
                </div>
                <br>
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    擁有者
                  </span>
                  <div class="form-control form-info">
                    <span v-if="activity.owner_type.value === 1">平台</span>
                    <span v-else-if="activity.owner_type.value === 2">品牌 - {{activity.owner_brand_name}}</span>
                    <span v-else-if="activity.owner_type.value === 3">店家 - {{activity.owner_brand_name}} - {{activity.owner_store_name}}</span>
                  </div>
                </div>
                <br>
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    參與品牌
                  </span>
                  <div class="form-control form-info">
                    {{brandSelect.label}}
                  </div>
                </div>
                <br>
              </div>
            </div>
            <div class="box-body form-right">
              <div>
                <div class="input-group cr-schedule">
                  <span class="input-group-addon">
                    活動開始時間
                  </span>
                  <div class="form-control form-info">
                    {{activity.aTime.start.time}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group cr-schedule">
                  <span class="input-group-addon">
                    活動結束時間
                  </span>
                  <div class="form-control form-info">
                    {{activity.aTime.end.time}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">活動說明</span>
                  <div class="form-control form-info">
                    {{activity.description}}
                  </div>
                </div>
                <br />
              </div>
            </div>
            <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    參與店家
                  </span>
                  <div class="form-control form-info" v-for="brand in info.attend_stores">
                    <div class="inline-block" v-for="store in brand.store_list" style="margin-bottom: 13px">
                      <label class="label label-primary m-r-5 m-b-5">
                        <div class="is-enable-store" :class="[store.is_enable?'success':'danger']"></div>
                        {{store.store_name}}
                      </label>
                    </div>
                  </div>
                </div>
                <br>
              </div>
              <!--
              <h5>參與店家</h5>
              <div>
                <div class="input-group">
                  <div class="form-control form-info">
                    <div v-for="brand in info.attend_stores">
                      <label class="label label-success" v-for="store in brand.store_list">
                        {{store.store_name}}
                      </label>
                    </div>
                  </div>
                </div>
                <br />
              </div>
              -->
              <br>
            </div>
            <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
              <h5>生效日設定</h5>
              <div class="m-t-10 process-time-block" v-for="(process, pIndex) in timeSettingList">
                <div v-if="!process.value_type">
                  <div class="input-group">
                    <span class="input-group-addon">時間類型</span>
                    <div class="form-control form-info">
                      <span v-if="!process.value_type">無指定</span>
                      <span v-else-if="process.value_type === 1">日期</span>
                      <span v-else-if="process.value_type === 2">星期</span>
                    </div>
                  </div>
                  <br>
                </div>
                <div v-if="process.value_type === 2">
                  <div class="input-group">
                    <span class="input-group-addon">
                      開始
                    </span>
                    <div class="form-control form-info">
                      <span>{{getWeekDay(process.start_value.value)}}</span>
                    </div>
                  </div>
                  <br />
                </div>
                <div v-if="process.value_type === 1">
                  <div class="input-group">
                    <span class="input-group-addon">
                      開始
                    </span>
                    <div class="form-control form-info">
                      <span>{{process.start_value.label}} 日</span>
                    </div>
                  </div>
                  <br />
                </div>
                <div v-if="process.value_type === 2">
                  <div class="input-group">
                    <span class="input-group-addon">
                      結束
                    </span>
                    <div class="form-control form-info">
                      <span>{{getWeekDay(process.end_value.value)}}</span>
                    </div>
                  </div>
                  <br />
                </div>
                <div v-if="process.value_type === 1">
                  <div class="input-group">
                    <span class="input-group-addon">
                      結束
                    </span>
                    <div class="form-control form-info">
                      <span>{{process.end_value.label}} 日</span>
                    </div>
                  </div>
                  <br />
                </div>
                <div v-if="process.time_type === 1">
                  <div class="input-group">
                    <span class="input-group-addon">
                      時段
                    </span>
                    <div class="form-control form-info">
                      <span>全時段</span>
                    </div>
                  </div>
                  <br />
                </div>
                <table class="table table-bordered table-striped dataTable" v-if="process.time_type === 2">
                  <thead class="bg-primary">
                  <tr>
                    <td>開始時間</td>
                    <td>結束時間</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, iIndex) in process.time_interval">
                    <td>
                      {{item.start_time}}
                    </td>
                    <td>
                      {{item.end_time}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <br>
            </div>
            <hr class="box-body col-xs-12">
            <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
              <div>
                <h4>限制規則</h4>
              </div>
            </div>
            <div class="box-body form-left">
              <div  v-if="activity.strategy_data.limit.order_types.length">
                <div class="input-group">
                  <span class="input-group-addon">
                    訂單類型
                  </span>
                  <div class="form-control form-info">
                    <label class="label label-success m-r-5" v-for="orderType in activity.strategy_data.limit.order_types">
                      {{orderType.label}}
                    </label>
                  </div>
                </div>
                <br>
              </div>
              <div v-if="activity.strategy_data.limit.order_methods.length" >
                <div class="input-group">
                  <span class="input-group-addon">
                    訂單方案
                  </span>
                  <div class="form-control form-info">
                    <label class="label label-success m-r-5"  v-for="orderMethod in activity.strategy_data.limit.order_methods">
                      {{orderMethod.label}}
                    </label>
                  </div>
                </div>
                <br>
              </div>
              <div v-if="activity.strategy_data.limit.delivery_types.length">
                <div class="input-group">
                  <span class="input-group-addon">
                    取貨方式
                  </span>
                  <div class="form-control form-info">
                    <label class="label label-success m-r-5"  v-for="deliveryType in activity.strategy_data.limit.delivery_types">
                      {{deliveryType.label}}
                    </label>
                  </div>
                </div>
                <br>
              </div>
              <div v-if="activity.strategy_data.limit.trade_types.length">
                <div class="input-group">
                  <span class="input-group-addon">
                    付款方式
                  </span>
                  <div class="form-control form-info">
                    <label class="label label-success m-r-5" v-for="tradeType in activity.strategy_data.limit.trade_types">
                      {{tradeType.label}}
                    </label>
                  </div>
                </div>
                <br>
              </div>
            </div>
            <div class="box-body form-right">
              <div v-if="activity.strategy_data.limit.min_product_money">
                <div class="input-group">
                  <span class="input-group-addon">訂單最低應付金額(單位：元)</span>
                  <div class="form-control form-info">
                    {{activity.strategy_data.limit.min_product_money}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="activity.strategy_data.limit.min_product_amount">
                <div class="input-group">
                  <span class="input-group-addon">限制主單(或團長)最低購買數(單位：個)</span>
                  <div class="form-control form-info">
                    {{activity.strategy_data.limit.min_product_amount}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="activity.strategy_data.limit.min_sub_order_amount">
                <div class="input-group">
                  <span class="input-group-addon">限制子單(跟團單)最低訂單數(單位：筆)</span>
                  <div class="form-control form-info">
                    {{activity.strategy_data.limit.min_sub_order_amount}}
                  </div>
                </div>
                <br />
              </div>
            </div>
            <hr class="box-body col-xs-12">
            <div class="col-xs-12 p-sm-10-p m-x-10 form-center box-body">
              <div style="margin-bottom: 20px">
                <h4>
                  折扣規則
                  <small v-if="activity.rule_code === 'SD00001'">&nbsp;&nbsp;買X送一依金額個位數取固定折抵規則</small>
                  <small v-else-if="activity.rule_code === 'SD00002'">&nbsp;&nbsp;買指定商品買X份可折Y元</small>
                  <small v-else-if="activity.rule_code === 'SD00003'">&nbsp;&nbsp;買X送Y依數量最低價格折抵規則</small>
                  <small v-else-if="activity.rule_code === 'SD00004'">&nbsp;&nbsp;全品項折扣規則</small>
                  <small v-else-if="activity.rule_code === 'SD00005'">&nbsp;&nbsp;購買X數量滿額可折Y元折抵規則</small>

                </h4>
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.amount_unit && (activity.rule_code === 'SD00001' || activity.rule_code === 'SD00005')">
                <div class="input-group">
                  <span class="input-group-addon">折扣滿足總數 (買X送一)</span>
                  <div class="form-control form-info">
                    買{{activity.strategy_data.setting.amount_unit}}送一
                  </div>
                </div>
                <br />
              </div>
              <div class="m-t-10" v-else-if="activity.strategy_data.setting.amount_unit && activity.strategy_data.setting.ratio && activity.rule_code === 'SD00003'">
                <div class="input-group">
                  <span class="input-group-addon">折扣滿足總數 (買X送Y)</span>
                  <div class="form-control form-info">
                    買{{activity.strategy_data.setting.amount_unit}}送{{activity.strategy_data.setting.ratio}}
                  </div>
                </div>
                <br />
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.lowest_unit_price !== ''">
                <div class="input-group">
                  <span class="input-group-addon">限制列入計算/折抵商品最低項目單價</span>
                  <div class="form-control form-info">
                    {{activity.strategy_data.setting.lowest_unit_price}} 元
                  </div>
                </div>
                <br />
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.one_max_discount">
                <div class="input-group">
                  <span class="input-group-addon">最大折扣金額</span>
                  <div class="form-control form-info">
                    {{activity.strategy_data.setting.one_max_discount}}
                  </div>
                </div>
                <br />
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.discount_unit">
                <div class="input-group">
                  <span class="input-group-addon">每達到數量贈送的金額</span>
                  <div class="form-control form-info">
                    {{activity.strategy_data.setting.discount_unit}}
                  </div>
                </div>
                <br />
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.percent_value">
                <div class="input-group">
                  <span class="input-group-addon">折扣數值</span>
                  <div class="form-control form-info">
                    {{activity.strategy_data.setting.percent_value}}
                  </div>
                </div>
                <br />
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.ignore_allowance">
                <div class="input-group">
                  <span class="input-group-addon">是否忽略折讓(A+B)金額</span>
                  <div class="form-control form-info">
                    {{activity.strategy_data.setting.ignore_allowance.label}}
                  </div>
                </div>
                <br />
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.round_policy">
                <div class="input-group">
                  <span class="input-group-addon">折扣金額小數點進位方式</span>
                  <div class="form-control form-info">
                    {{activity.strategy_data.setting.round_policy.label}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="activity.strategy_data.setting.product_info.length || activity.strategy_data.store_exception_items[0].products.length" style="margin-bottom: 20px">
                <h5 v-if="ruleCode === 'SD00001' || ruleCode === 'SD00003'|| ruleCode === 'SD00004'|| ruleCode === 'SD00005'">例外商品</h5>
                <h5 v-else>折扣商品</h5>
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.product_info.length">
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                  <tr>
                    <td>＃</td>
                    <td>商品</td>
                    <td>商品料號</td>
                    <td>折扣規則</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(aProduct, aIndex) in activity.strategy_data.setting.product_info">
                    <td>
                      {{aIndex + 1}}
                    </td>
                    <td>
                      {{aProduct.product_name}}
                    </td>
                    <td>
                      <div class="text-primary c-pointer" data-toggle="modal"
                           data-target="#storeProdModal" @click="getStoreProd(aProduct)">
                      {{aProduct.vendor_custom_id}}
                        </div>
                    </td>
                    <td>
                      購買&nbsp;&nbsp;{{aProduct.amount_unit}}&nbsp;&nbsp;個
                      折&nbsp;&nbsp;{{aProduct.discount}}&nbsp;&nbsp;元
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.store_exception_items[0].products.length">
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                  <tr>
                    <td>＃</td>
                    <td>商品</td>
                    <td>商品料號</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(aProduct, aIndex) in activity.strategy_data.store_exception_items[0].products">
                    <td>
                      {{aIndex + 1}}
                    </td>
                    <td>
                      {{aProduct.product_name}}
                    </td>
                    <td>
                      <div class="text-primary c-pointer" data-toggle="modal"
                           data-target="#storeProdModal" @click="getStoreProd(aProduct)">
                      {{aProduct.vendor_custom_id}}
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="m-t-10" v-if="activity.strategy_data.setting.exception_products.length">
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                  <tr>
                    <td>＃</td>
                    <td>商品</td>
                    <td>商品料號</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(aProduct, aIndex) in activity.strategy_data.setting.exception_products">
                    <td>
                      {{aIndex + 1}}
                    </td>
                    <td>
                      {{aProduct.product_name}}
                    </td>
                    <td>
                      <div class="text-primary c-pointer" data-toggle="modal"
                           data-target="#storeProdModal" @click="getStoreProd(aProduct)">
                        {{aProduct.vendor_custom_id}}
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!--<div class="col-xs-12">-->
            <!--<div class="box-body">-->
            <!--<div class="dataTables_wrapper form-inline dt-bootstrap">-->
            <!--<storelist-table :storeList="getList" @getIndex="getNewList"/>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- /.box-body -->
    <div class="modal fade" role="dialog" id="storeProdModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{curVCID}} 出現的門市</h4>
          </div>
          <div class="modal-body">
            <table class="table table-bordered table-striped dataTable">
              <thead class="bg-primary">
              <tr>
                <td>＃</td>
                <td>商品 (ID)</td>
                <td>門市</td>
                <td>菜單</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(sProd, aIndex) in storeProdList">
                <td>
                  {{aIndex + 1}}
                </td>
                <td>
                  <div v-if="sProd.product_id">
                    {{sProd.product_name}} ({{sProd.product_id}})
                  </div>
                  <div class="text-red" v-else>無對應的商品</div>
                </td>
                <td>{{sProd.store_name}}</td>
                <td>
                  <div v-if="sProd.menu_id">
                    {{sProd.menu_name}}
                  </div>
                  <div class="text-red" v-else>無使用中菜單</div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import menuDiscount from './MenuDiscountTemp.vue'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  props: ['isUp'],
  components: {
    'date-time-picker': datetimePicker,
    'menu-discount': menuDiscount
  },
  data () {
    return {
      setInfoTimes: 0,
      info: {},
      reSet: 0,
      ruleCode: 'SD00002',
      brandSelect: {
        label: '',
        value: ''
      },
      menuSelect: {
        label: '',
        value: 0
      },
      // modal test
      ownerTypeOptions: [
        {label: '品牌', value: 2},
        {label: '門市', value: 3},
        {label: '平台', value: 1}
      ],
      enableOptions: [
        {label: '啟用', value: 1},
        {label: '停用', value: 0}
      ],
      timeTypeOption: [
        {label: '全時段', value: 1},
        {label: '指定時段', value: 2}
      ],
      orderType: [
        {label: '一般單', value: 1},
        {label: '團購單 - 團長', value: 2},
        {label: '團購單 - 團員', value: 3}
      ],
      orderMethod: [
        {label: '當日單', value: 1},
        {label: '預訂單', value: 2}
      ],
      deliveryType: [
        {label: '自取', value: 1},
        {label: '內用', value: 2},
        {label: '外送', value: 3},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      tradeType: [],
      menuList: [],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },
      priceType: [
        {label: '免稅', value: 1},
        {label: '未稅', value: 2},
        {label: '含稅', value: 3}
      ],
      couponSetting: [
        {label: '依訂單購買商品數設定', value: 'SC00001'},
        {label: '依個人訂單消費特定商品數', value: 'SC00002'},
        {label: '依個人訂單購買金額', value: 'SC00003'}
      ],
      useType: [
        {label: '品牌型', value: 2},
        {label: '門市型', value: 3}
      ],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false,
        info: false
      },
      tableIndex: 1,
      count: 20,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      timeoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          from: moment().add(-1, 'days').format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().add(-1, 'days').format('YYYY-MM-DD')
        }
      ],
      offdaySetting: {
        date: [],
        weekDay: [],
        monthDay: [],
        options: {
          date: [
            // {label: '無指定', value: 0}
          ],
          weekDay: [
            // {label: '無指定', value: 0},
            {label: '週日', value: 1},
            {label: '週一', value: 2},
            {label: '週二', value: 3},
            {label: '週三', value: 4},
            {label: '週四', value: 5},
            {label: '週五', value: 6},
            {label: '週六', value: 7}
          ],
          month: [
            // {label: '無指定', value: 0},
            {label: '一月', value: 1},
            {label: '二月', value: 2},
            {label: '三月', value: 3},
            {label: '四月', value: 4},
            {label: '五月', value: 5},
            {label: '六月', value: 6},
            {label: '七月', value: 7},
            {label: '八月', value: 8},
            {label: '九月', value: 9},
            {label: '十月', value: 10},
            {label: '十一月', value: 11},
            {label: '十二月', value: 12}
          ],
          monthDay: [
            // {label: '無指定', value: 0}
          ]
        }
      },
      timeSettingList: [
        { value_type: 0, start_value: 0, end_value: 0, time_type: 1, time_interval: [] }
      ],
      activity: {
        name: '',
        description: '',
        rule_code: 'SD00002',
        start_date: '',
        end_date: '',
        is_enable: {label: '啟用', value: 1},
        owner_type: {label: '品牌', value: 2},
        owner_id: 0,
        owner_brand_name: '',
        owner_store_name: '',
        aTime: {
          start: { time: '' },
          end: { time: '' }
        },
        time_setting: [],
        store_ids: [],
        strategy_data: {
          limit: {
            delivery_types: [],
            order_types: [],
            trade_types: [],
            order_methods: [],
            min_product_money: '',
            min_product_amount: '',
            min_sub_order_amount: ''
          },
          setting: {
            // SD00002
            one_max_discount: '',
            product_info: [],
            // SD00001、SD00003
            amount_unit: '',
            // SD00003
            lowest_unit_price: 0,
            ratio: '',
            exception_products: [],
            // SD00004
            percent_value: '',
            ignore_allowance: { label: '不忽略折讓(A+B)金額，商品總額扣除折讓計算', value: 0 },
            round_policy: { label: '小數四折五入', value: 'round' },
            // SD00005
            discount_unit: ''
          },
          // SD00001
          store_exception_items: [
            {
              products: [],
              store_ids: []
            }
          ]
        }
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: moment().format('YYYY-MM-DD HH:mm'),
      storeList: [],
      storeSelect: {label: '', value: ''},
      storeProdList: [],
      curVCID: '',
      ignoreAllowance: [
        { label: '不忽略折讓(A+B)金額，商品總額扣除折讓計算', value: 0 },
        { label: '忽略折讓(A+B)金額，商品總額不扣除折讓計算', value: 1 }
      ],
      roundPolicy: [
        { label: '小數四折五入', value: 'round' },
        { label: '小數無條件捨去', value: 'floor' },
        { label: '小數無條件進位', value: 'ceil' }
      ]
    }
  },
  created () {
    this.getBrandBrief()
    this.getTradeTypeList()
    // 店家
    if (this.getRoleType === 10) {
      this.useType = [
        {label: '品牌型', value: 2},
        {label: '門市型', value: 3}
      ]
    }
    // this.getStoreBrief()
  },
  methods: {
    ...mapActions(['setMenuStartTime', 'setMenuEndTime']),
    getStoreProd (prod) {
      this.curVCID = prod.vendor_custom_id
      const self = this
      const vcId = prod.vendor_custom_id
      var url = '/discount/' + this.$route.params.activity_id + '/storeOnlineProduct?vendor_custom_id=' + vcId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeProdList = response.data.list
        }
      })
    },
    getWeekDay (value) {
      return this.offdaySetting.options.weekDay.find(function (week) { return value === week.value }).label
    },
    returnNum (e) {
      var charCode = (e.which) ? e.which : e.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault()
      } else {
        return true
      }
    },
    addProdToList (addPInfo) {
      var self = this
      var pInfo = this.activity.strategy_data.setting.product_info
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id
        })
        if (!isSame) pInfo.push(addP)
        else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          })
        }
      })
    },
    sameItem (list, index) {
      var getAmount = list[index].amount_unit
      var getDiscount = list[index].discount
      list.forEach(function (o) {
        o.amount_unit = getAmount
        o.discount = getDiscount
      })
    },
    removeListItem (list, index) {
      list.splice(index, 1)
    },
    clearProcess (process) {
      process.end_value = ''
      process.start_value = ''
    },
    changeTimeType (process) {
      if (process.time_type === 2) {
        var item = {
          start_time: '',
          end_time: ''
        }
        if (!process.time_interval.length) process.time_interval.push(item)
      } else {
        process.time_interval = []
      }
    },
    addProcessTime () {
      var timeSetting = { value_type: 0, start_value: 0, end_value: 0, time_type: 1, time_interval: [] }
      this.timeSettingList.push(timeSetting)
    },
    addChooseTag (newTag) {
      const tag = {
        name: newTag,
        id: ''
      }
      this.productChoseBrief.push(tag)
      this.activity.setting.vendorCustomProductList.push(tag)
    },
    addItemTime (process) {
      var item = {
        start_time: '',
        end_time: ''
      }
      process.time_interval.push(item)
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        vendor_custom_id: ''
      }
      this.productBrief.push(tag)
      this.activity.store_exception_items[0].products.push(tag)
    },
    addStartMonthDayTag (newTag, id) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.monthDay.push(tag)
      // this.offdaySetting.monthDay.push(tag)
    },
    addEndMonthDayTag (newTag, id) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.monthDay.push(tag)
      // this.offdaySetting.monthDay.push(tag)
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      this.addStoresSetting.options = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            self.addStoresSetting.options.push(obj)
          }
          if (self.info && !self.setInfoTimes) self.getDiscountInfo()
          else if (self.info && self.setInfoTimes === 1) self.setStore()
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            if (i === 0) self.brandSelect = obj
          }
        }
      })
    },
    getDiscountInfo () {
      var self = this
      var url = '/discount/' + this.$route.params.activity_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data
          self.setInfo()
        }
      })
    },
    setStore () {
      var self = this
      let stores = this.info.attend_stores
      if (stores.length) {
        stores[0].store_list.forEach(function (store) {
          self.addStoresSetting.choose.push(store.store_id)
        })
      }
    },
    setInfo () {
      this.setInfoTimes++
      let a = this.activity
      let i = this.info.info
      let times = this.info.time_setting
      let strategy = this.info.strategy_data[0]
      let stores = this.info.attend_stores
      var self = this
      a.name = i.name
      a.description = i.description
      a.rule_code = this.ruleCode = i.rule_code
      a.owner_brand_name = i.owner_brand_name
      a.owner_store_name = i.owner_store_name
      // date
      a.aTime.start.time = i.start_date
      a.aTime.end.time = i.end_date
      a.is_enable = this.enableOptions.find(function (o) { return o.value === i.is_enable })
      a.owner_type = this.ownerTypeOptions.find(function (o) { return o.value === i.owner_type })
      this.brandSelect = this.brandBrief.find(function (o) { return o.value === stores[0].brand_id }) // 取參與店家裡的品牌
      this.timeSettingList = []
      // time
      times.forEach(function (time) {
        let option = {
          end_value: {label: time.end_value, value: time.end_value},
          start_value: {label: time.start_value, value: time.start_value},
          time_type: time.time_type,
          value_type: time.value_type,
          time_interval: time.time_interval
        }
        self.timeSettingList.push(option)
      })
      if (a.rule_code === 'SD00001') {
        let iLimit = strategy.limit
        let aLimit = a.strategy_data.limit
        // limit
        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType }))
          })
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType }))
          })
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) { return o.value === tType }))
          })
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount
        // setting
        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit
        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name)
          })
        }
      } else if (a.rule_code === 'SD00002') {
        let iLimit = strategy.limit
        let aLimit = a.strategy_data.limit
        // limit
        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType }))
          })
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType }))
          })
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) { return o.value === tType }))
          })
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount
        // setting
        if (strategy.setting.one_max_discount) a.strategy_data.setting.one_max_discount = strategy.setting.one_max_discount
        a.strategy_data.setting.product_info = strategy.setting.product_info
      } else if (a.rule_code === 'SD00003') {
        let iLimit = strategy.limit
        let aLimit = a.strategy_data.limit
        // limit
        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType }))
          })
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType }))
          })
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) { return o.value === tType }))
          })
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount
        // setting
        // 明天從這裡開始
        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit
        if (strategy.setting.lowest_unit_price) a.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price
        if (strategy.setting.ratio) a.strategy_data.setting.ratio = strategy.setting.ratio
        if (strategy.setting.exception_products.length) {
          a.strategy_data.setting.exception_products = strategy.setting.exception_products
          strategy.setting.exception_products.forEach(function (prod, pIndex) {
            self.$set(a.strategy_data.setting.exception_products[pIndex], 'product_name', prod.name)
          })
        }
      } else if (a.rule_code === 'SD00004') {
        let iLimit = strategy.limit
        let aLimit = a.strategy_data.limit
        // limit
        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType }))
          })
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType }))
          })
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) { return o.value === tType }))
          })
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount
        // setting
        console.log(strategy.setting)
        if (strategy.setting.percent_value) a.strategy_data.setting.percent_value = strategy.setting.percent_value
        if (strategy.setting.ignore_allowance !== '') {
          a.strategy_data.setting.ignore_allowance = this.ignoreAllowance.find(function (option) { return option.value === strategy.setting.ignore_allowance })
        }
        if (strategy.setting.round_policy) {
          a.strategy_data.setting.round_policy = this.roundPolicy.find(function (option) { return option.value === strategy.setting.round_policy })
        }
        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name)
          })
        }
      } else if (a.rule_code === 'SD00005') {
        let iLimit = strategy.limit
        let aLimit = a.strategy_data.limit
        // limit
        if (iLimit.delivery_types) {
          iLimit.delivery_types.forEach(function (dType) {
            aLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType }))
          })
        }
        if (iLimit.order_types) {
          iLimit.order_types.forEach(function (oType) {
            aLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType }))
          })
        }
        if (iLimit.trade_types) {
          iLimit.trade_types.forEach(function (tType) {
            aLimit.trade_types.push(self.tradeType.find(function (o) { return o.value === tType }))
          })
        }
        if (iLimit.order_methods) {
          iLimit.order_methods.forEach(function (oMethod) {
            aLimit.order_methods.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
        }
        if (iLimit.min_product_money) aLimit.min_product_money = iLimit.min_product_money
        if (iLimit.min_product_amount) aLimit.min_product_amount = iLimit.min_product_amount
        if (iLimit.min_sub_order_amount) aLimit.min_sub_order_amount = iLimit.min_sub_order_amount
        // setting
        console.log(strategy.setting)
        if (strategy.setting.amount_unit) a.strategy_data.setting.amount_unit = strategy.setting.amount_unit
        a.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price
        if (strategy.setting.discount_unit) a.strategy_data.setting.discount_unit = strategy.setting.discount_unit

        if (strategy.store_exception_items.length) {
          a.strategy_data.store_exception_items = strategy.store_exception_items
          a.strategy_data.store_exception_items[0].products.forEach(function (prod) {
            self.$set(prod, 'product_name', prod.name)
          })
        }
      }
      self.show.info = true
      /*
      if (i.owner_type === 1) a.owner_id = 0
      else if (i.owner_type === 2) this.brandSelect.value = this.brandBrief.find(function (o) { return o.value === i.owner_id })
      */
      // else if (i.owner_type === 3) this.addStoresSetting.choose = data.store_ids[0]
    },
    getTradeTypeList () {
      var self = this
      var url = '/platform/tradeTypeList'
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = []
          var list = response.data.list
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid && list[i].is_enable) {
              var option = {
                label: list[i].name,
                value: parseInt(list[i].type, 10)
              }
              self.tradeType.push(option)
            }
          }
        }
      })
    },
    checkActivity () {
      var a = this.activity
      var sD = a.strategy_data // 活動策略
      var msg = ''
      if (!a.name) msg = '活動名稱未填'
      else if (!a.aTime.start.time) msg = '活動開始時間未填'
      else if (!a.aTime.end.time) msg = '活動結束時間未填'
      else if (!a.owner_type.value) msg = '活動擁有者未選'
      else if (!a.is_enable) msg = '活動啟用未選'
      else if (!a.description) msg = '活動描述未填'
      else if (!this.timeSettingList.length) msg = '折扣生效日未填'
      else if (!this.addStoresSetting.choose.length) msg = '參與活動店家未選'
      else if (this.addStoresSetting.choose.length > 1 && a.owner_type === 3) msg = '品牌擁有者只可選擇一家店家'
      else if (a.rule_code === 'SD00001') {
        // 須更新
      } else if (a.rule_code === 'SD00002') {
        if (!sD.setting.product_info.length) msg = '扣商品選擇未選'
      }
      this.getToast(msg)
    },
    getToast (msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.setData()
      }
    },
    setData (type) {
      var act = this.activity
      var data = {
        name: act.name,
        description: act.description,
        rule_code: act.rule_code,
        start_date: act.aTime.start.time,
        end_date: act.aTime.end.time,
        is_enable: act.is_enable.value,
        owner_type: act.owner_type.value,
        owner_id: 0,
        time_setting: [],
        store_ids: this.addStoresSetting.choose,
        strategy_data: {}
      }
      // owner_type
      if (data.owner_type === 1) data.owner_id = 0
      else if (data.owner_type === 2) data.owner_id = this.brandSelect.value
      else if (data.owner_type === 3) data.owner_id = data.store_ids[0]
      // time_setting
      this.timeSettingList.forEach(function (time) {
        let o = {
          value_type: 0,
          start_value: 0,
          end_value: 0,
          time_type: 1,
          time_interval: time.time_interval
        }
        if (time.value_type) o.value_type = time.value_type.value
        if (time.start_value) o.value_type = time.start_value.value
        if (time.end_value) o.value_type = time.end_value.value
        data.time_setting.push(o)
      })
      if (act.rule_code === 'SD00002') {
        let aSD = act.strategy_data
        data.strategy_data = {
          limit: {},
          setting: {
            one_max_discount: null,
            product_info: aSD.setting.product_info
          }
        }
        let dSD = data.strategy_data
        // limit
        if (aSD.limit.delivery_types.length) {
          dSD.limit.delivery_types = []
          aSD.limit.delivery_types.forEach(function (dType) {
            dSD.limit.delivery_types.push(dType.value)
          })
        }
        if (aSD.limit.order_types.length) {
          dSD.limit.order_types = []
          aSD.limit.order_types.forEach(function (oType) {
            dSD.limit.order_types.push(oType.value)
          })
        }
        if (aSD.limit.trade_types.length) {
          dSD.limit.trade_types = []
          aSD.limit.trade_types.forEach(function (tType) {
            dSD.limit.trade_types.push(tType.value)
          })
        }
        if (aSD.limit.order_methods.length) {
          dSD.limit.order_methods = []
          aSD.limit.order_methods.forEach(function (oMethod) {
            dSD.limit.order_methods.push(oMethod.value)
          })
        }
        if (aSD.limit.min_product_money) dSD.limit.min_product_money = aSD.limit.min_product_money
        if (aSD.limit.min_product_amount) dSD.limit.min_product_amount = aSD.limit.min_product_amount
        if (aSD.limit.min_sub_order_amount) dSD.limit.min_sub_order_amount = aSD.limit.min_sub_order_amount
        // setting
        if (aSD.setting.one_max_discount) dSD.setting.one_max_discount = aSD.setting.one_max_discount
      }
      if (this.info.info) this.upDiscount(data)
      else this.crDiscount(data)
    },
    crDiscount (data) {
      var self = this
      var url = '/discount'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/upDiscountList')
          // self.total = response.data.total
        }
      })
    },
    upDiscount (data) {
      var self = this
      var url = '/discount/' + this.$route.params.activity_id
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/upDiscountList')
          // self.total = response.data.total
        }
      })
    },
    getOnlineMenu () {
      var self = this
      self.menuList = []
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + this.brandSelect.value + '&store_id=' + this.storeSelect.value
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mList = response.data.menu_list
          mList.forEach(function (menu, index) {
            var option = {label: menu.name, value: menu.id}
            self.menuList.push(option)
            if (index === 0) self.menuSelect = option
          })
          if (!mList.length) self.menuSelect = {label: '', value: ''}
          // self.total = response.data.total
        }
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  },
  watch: {
    'menuTime.start.time' () {
      this.endLimit = [
        {
          type: 'fromto',
          from: this.menuTime.start.time
        }
      ]
      this.setMenuStartTime(this.menuTime.start.time)
    },
    'menuTime.end.time' () {
      this.startLimit = [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss'),
          to: this.menuTime.end.time
        }
      ]
      this.setMenuEndTime(this.menuTime.end.time)
    },
    'content.bindingBrandList' () {
      var self = this
      this.storeBrief = []
      this.content.bindingStoreList = []
      this.content.bindingBrandList.forEach(function (array) {
        const brandId = array.value
        self.getStoreBrief(brandId)
      })
    },
    'addStoresSetting.choose' () {
      var self = this
      this.activity.store_ids = this.addStoresSetting.choose
      this.storeList = []
      this.addStoresSetting.choose.forEach(function (id) {
        self.addStoresSetting.options.find(function (o) {
          if (o.value === id) self.storeList.push(o)
        })
      })
      if (this.storeList.length) this.storeSelect = this.storeList[0]
    },
    'brandSelect.value' () {
      this.getStoreBrief(this.brandSelect.value)
      this.addStoresSetting.choose = []
    },
    'storeSelect.value' () {
      if (this.storeSelect.value) this.getOnlineMenu()
    }
  }
}
</script>
<style lang="sass">
.is-enable-store
  width: 10px
  height: 10px
  border-radius: 50%
  display: inline-block
  background-color: white
  margin-right: 5px
  &.danger
    background-color: #dd4b39
  &.success
    background-color: #00a65a
.coupon-left
  float: left
  width: calc(100% / 3 * 2 + 15px)
  padding-right: 5px
.coupon-right
  float: left
  background: #3c8dbc
  width: calc(100% / 3 - 15px)
  position: absolute
  right: 0
  top: 0
  height: 100%
  border-left: 5px black dashed
  border-radius: 0px 6px 6px 0px
  color: white
  .v-middle
    position: absolute
    top: calc(50% - 28.5px)
    font-size: 40px
    text-align: center
    width: 100%
    left: 0
</style>
<style lang="sass" scoped>
// .ranges
  display: none
.coupon.form-left, .coupon.form-right
  width: 50%
  float: left
.coupon.form-right
  padding: 20px 20px 20px 10px
.coupon.form-left
  padding: 20px 10px 20px 20px
.coupon.form-left.w-100-p
  padding: 20px 20px
.min-item.active, .hour-item.active, .day.checked
  background: #222d32 !important
.w-200
  width: 180px !important
.m-b-15
  margin-bottom: 15px !important
.btn-all-store
  position: absolute
  right: 10px
  z-index: 30
  top: 0px
.input-white
  border: 0px
@media screen and (max-width: 767px)
  .p-sm-10-p
    padding-right: 10px !important
    padding-left: 10px !important
@media screen and (min-width: 768px)
  .p-sm-10-p
    padding-right: calc(20% - 15px) !important
    padding-left: calc(20% + 10px) !important
@media screen and (min-width: 991px)
  .p-sm-10-p
    padding-right: calc(10% - 10px) !important
    padding-left: 10% !important
</style>
<style lang="sass">
  .multiselect__content-wrapper, .multiselect__content-wrapper *
    z-index: 99
  .m-t-0
    margin-top: 0px
  .input-group .form-control
    z-index: auto !important
  textarea
    max-width: 100%
    min-widht: 100%
  .modal-title
    width: calc(100% - 20px)
  @media screen and (max-width: 767px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(100vw - 185px)
  @media screen and (min-width: 768px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(50vw - 190px)
  @media screen and (min-width: 991px)
    .input-group .cov-vue-date .cov-datepicker
      max-width: calc(30vw - 190px)
</style>



// WEBPACK FOOTER //
// DiscountInfo.vue?8ae4ad54